import { useSelector } from "react-redux";
import { selectMap } from "../../features/counter/counterSlice";
import { MenuItem } from "./MenuItem";
import style from "./GuidelineNav.module.scss";
import icons from "../../scss/guidelineicons.module.scss";
import { filterMenuItems } from "./filterMenuItems";
import classNames from "classnames";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import generateMenuFromXml from "./guidelineMenuGenerator";
import { useEffect, useState } from "react";
import { isNullOrEmpty } from "../../utils/isNullOrEmpty";

const GuidelineNavWeb = ({ glObj }) => {
  const dartMap = useSelector(selectMap);
  const navigate = useNavigate();
  const [menuItems, setMenuItems] = useState({});
  const [rootGuideline, setRootGuideline] = useState(null);
  const [glInfo, setGlInfo] = useState(null);

  useEffect(() => {
    if (!glObj) {
      return;
    }
    const parsed = generateMenuFromXml(`${dartMap}`);
    const {
      menuItems: newMenuItems,
      rootGuideline,
      glInfo,
    } = filterMenuItems({
      glObj,
      menuJson: parsed,
    });

    if (!isNullOrEmpty(newMenuItems?.items)) {
      setMenuItems(newMenuItems);
      setRootGuideline(rootGuideline);
      setGlInfo(glInfo);
    }
  }, [glObj, dartMap]);

  if (!glObj) {
    return null;
  }

  const iconClass = classNames(icons.squareIcon, icons.iconSize32, icons[glInfo?.iconClassSuffix]);

  const topicMenus = menuItems?.items?.filter(
    (props) => !props.msPath?.includes("-tables-boxes-figures"),
  );
  const chapterRoot = glObj.glPage.replaceAll(" ", "_");
  const goTopic = () => {
    if (rootGuideline) {
      navigate(`/guidelines/${chapterRoot}`);
    }
  };

  // convert the guideline base path for quick links
  const getBaseInPath = (base) => {
    return base === "quicklinks" ? glInfo.onClickProps.replaceAll(" ", "_") : base;
  };
  return (
    <div className={style.guidelineNavWrapper}>
      <div className={style.header}>
        {rootGuideline && <div className={iconClass} role="img"></div>}
        <h3 className={`${rootGuideline ? "size-20" : "size-36"} semibold`} onClick={goTopic}>
          {menuItems?.title}
        </h3>
      </div>

      <div>
        {topicMenus?.map((props, index) => (
          <MenuItem
            {...props}
            key={`menu-${index}`}
            base={getBaseInPath(glObj.glPage)}
            hasIconOption={!rootGuideline}
          ></MenuItem>
        ))}
      </div>
    </div>
  );
};

GuidelineNavWeb.propTypes = {
  glObj: PropTypes.object.isRequired,
};

export default GuidelineNavWeb;
